import CurrenciesActionTypes from './currencies-types'

export const startGetCurrenciesFromAssets = data => ({
    type: CurrenciesActionTypes.START_GET_CURRENCIES_FROM_ASSETS,
    payload: data,
})

export const successGetCurrenciesFromAssets = data => ({
    type: CurrenciesActionTypes.SUCCESS_GET_CURRENCIES_FROM_ASSETS,
    payload: data,
})

export const failureGetCurrenciesFromAssets = data => ({
    type: CurrenciesActionTypes.FAILURE_GET_CURRENCIES_FROM_ASSETS,
    payload: data,
})

export const finishGetCurrenciesFromAssets = data => ({
    type: CurrenciesActionTypes.FINISH_GET_CURRENCIES_FROM_ASSETS,
    payload: data,
})

export const startGetCurrencies = data => ({
    type: CurrenciesActionTypes.START_GET_CURRENCIES,
    payload: data,
})

export const successGetCurrencies = data => ({
    type: CurrenciesActionTypes.SUCCESS_GET_CURRENCIES,
    payload: data,
})

export const failureGetCurrencies = data => ({
    type: CurrenciesActionTypes.FAILURE_GET_CURRENCIES,
    payload: data,
})

export const finishGetCurrencies = data => ({
    type: CurrenciesActionTypes.FINISH_GET_CURRENCIES,
    payload: data,
})
